import React from 'react';
import {
  chasingIcon,
  connectedIcon,
  disconnectedIcon,
  pausedIcon,
} from '../../../../../../assets/status-icons/index';
import Label from '../../../../../../components/Label/index';

import style from './ClientName.module.scss';

const iconMap = (row) => {
  if (!row?.isConnected) return disconnectedIcon;
  if (!row?.isChasing) return pausedIcon;
  if (row?.isChasing) return chasingIcon;
  if (row?.isConnected) return connectedIcon;
  if (row?.isDisabled) return pausedIcon;

  return null;
};

export default (name, row) => (
  <div className={style.clientName}>
    <img className={style.icon} alt="status-icon" src={iconMap(row)} />
    {name}
    {row?.isPartnerFree && <Label text="PARTNER FREE" />}
    {row?.isLifetimeFree && <Label text="LIFETIME FREE" />}
  </div>
);
